import { inject, Injectable } from "@angular/core";
import { UserPreferencesRequest } from "@models/api-models/request-models/userPreferencesRequestModel";
import { UserPreferencesResponse } from "@models/api-models/response-models/userPreferencesResponseModel";
import { CustomiserApiService } from "./customiser-api.service";

@Injectable({
	providedIn: 'root'
})
export class UserPreferencesService {

	customiserApi = inject(CustomiserApiService);

	constructor() { }

	public async PostUserPreferences(request: UserPreferencesRequest) {
		return await this.customiserApi.postJson('UserPreferences/updateOrCreateUserPreferences', request);
	}

	public async GetUserPreferences(contactCode: string) {
		return await this.customiserApi.get<UserPreferencesResponse>(`UserPreferences/getUserPreferences?contactCode=${contactCode}`);
	}

}